import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import { IPayload } from 'models/Global'
import { IGetGigDaysParams, IGigDay } from 'models/GigDay'

export class GigDaysApi {
  constructor(private axios: AxiosService) {}

  getGigDays = async (params?: IGetGigDaysParams) => {
    const response = await this.axios.get<IPayload<IGigDay[]>>(
      Endpoints.getGigDays,
      params,
    )
    return response
  }
}
